import { Component, Input, OnInit } from '@angular/core';
import { CookiesService } from 'src/app/CookieService';
import { SiteDetailsModel } from 'src/app/models/SiteDetails/SiteDetailsModel';
import { hexToBase64 } from 'src/app/shared/utils';

@Component({
	selector: 'app-site-details-banner',
	templateUrl: './site-details-banner.component.html',
	styleUrls: ['./site-details-banner.component.scss']	
})
export class SiteDetailsBannerComponent implements OnInit {
	@Input() public siteDetails: SiteDetailsModel;
	@Input() public siteName: string;

	get siteImage() : string { 

		const img = this.siteDetails?.SitePhoto ?? "assets/images/SiteDetails/Default_img_web.png";
		return img;
	}

	ngOnInit(): void {
		
	}
}
